import { FC } from 'react'
import { ZoningUsesFilterContent } from 'src/components/insights/zoning/uses/filter'

type ParcelZoningUsesFilterProps = {
  value: string
  onChange: (value: string) => void
}

export const ParcelZoningUsesFilter: FC<ParcelZoningUsesFilterProps> = ({ onChange, value }) => {
  return <ZoningUsesFilterContent value={value} onChange={onChange} />
}
